<template>
  <div class="products-soap-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="products-soap-fragment10">
          <span class="products-soap-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="products-soap-fragment11">
          <span class="products-soap-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="products-soap-fragment12">
          <span class="products-soap-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="products-soap-fragment13">
          <span class="products-soap-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="products-soap-fragment14">
          <span class="products-soap-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="products-soap-fragment15">
          <span class="products-soap-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="products-soap-fragment16">
          <span class="products-soap-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="products-soap-fragment17">
          <span class="products-soap-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="products-soap-fragment18">
          <span class="products-soap-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="products-soap-fragment19">
          <span class="products-soap-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="products-soap-fragment20">
          <span class="products-soap-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="products-soap-fragment21">
          <span class="products-soap-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="products-soap-fragment22">
          <span class="products-soap-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="products-soap-fragment23">
          <span class="products-soap-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <features-soap
      feature1ImageSrc="/walkwoods-600w.jpg"
      feature2ImageSrc="/juniper-600w.jpg"
      feature3ImageSrc="/mint-600w.jpg"
    >
      <template v-slot:sectionTitle>
        <div class="products-soap-fragment24">
          <span class="products-soap-text24">Hand-Made Soaps</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="products-soap-fragment25">
          <span class="products-soap-text25">
            <span>Walk in the Woods</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="products-soap-fragment26">
          <span class="products-soap-text28">
            <span>Juniper Orange</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="products-soap-fragment27">
          <span class="products-soap-text31">
            <span>Double Mint</span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Title>
        <div class="products-soap-fragment28">
          <span class="products-soap-text34">Gardening Services</span>
        </div>
      </template>
      <template v-slot:sectionTitle1>
        <div class="products-soap-fragment29">
          <span class="products-soap-text35">* Organic materials.</span>
        </div>
      </template>
      <template v-slot:feature1Button>
        <div class="products-soap-fragment30">
          <span class="products-soap-text36">Buy ($8.00)</span>
        </div>
      </template>
      <template v-slot:feature2Button>
        <div class="products-soap-fragment31">
          <span class="products-soap-text37">Buy ($8.00)</span>
        </div>
      </template>
      <template v-slot:feature3Button>
        <div class="products-soap-fragment32">
          <span class="products-soap-text38">Buy ($8.00)</span>
        </div>
      </template>
      <template v-slot:feature4Button>
        <div class="products-soap-fragment33">
          <span class="products-soap-text39">
            Learn More about Gardening Services
          </span>
        </div>
      </template>
      <template v-slot:sectionTitle11>
        <div class="products-soap-fragment34">
          <span class="products-soap-text40">
            <span>
              All Natural soaps, made in small batches by Wildwood Herbs
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="products-soap-fragment35">
          <span class="products-soap-text43">
            <span>
              *Olive oil, water, *coconut oil, sodium hydroxide, *sweet almond
              oil, *caster oil, cedarwood, clove and vetiver essential oils,
              spirulina for color.
              <span v-html="rawtnph"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="products-soap-fragment36">
          <span class="products-soap-text46">
            <span>
              *Olive oil (infused with marshmallow and lavender), water, *coconut
              oil, sodium hydroxide, *sweet almond oil, *caster oil, essential
              oils (juniper and orange), annatto for color.
              <span v-html="rawk1fv"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="products-soap-fragment37">
          <span class="products-soap-text49">
            <span>
              *Olive oil (infused with japanese knotweed and calendula), water,
              *coconut oil, sodium hydroxide, *sweet almond oil, *caster oil,
              essential oils (peppermint and spearmint), chlorophyll.
              <span v-html="rawgph0"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature4Description>
        <div class="products-soap-fragment38">
          <span class="products-soap-text52">
            Let us help you create your own herbal garden for a sustainable
            wellness lifestyle.
          </span>
        </div>
      </template>
    </features-soap>
    <app-footer4 rootClassName="footer4root-class-name1">
      <template v-slot:termsLink>
        <div class="products-soap-fragment39">
          <span class="products-soap-text53">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="products-soap-fragment40">
          <span class="products-soap-text54">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="products-soap-fragment41">
          <span class="products-soap-text55">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import FeaturesSoap from '../components/features-soap'
import AppFooter4 from '../components/footer4'

export default {
  name: 'ProductsSoap',
  props: {},
  components: {
    AppNavbar8,
    FeaturesSoap,
    AppFooter4,
  },
  data() {
    return {
      rawtnph: ' ',
      rawk1fv: ' ',
      rawgph0: ' ',
    }
  },
  metaInfo: {
    title: 'Products-Soap - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Products-Soap - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.products-soap-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.products-soap-fragment10 {
  display: contents;
}
 
.products-soap-text10 {
  display: inline-block;
}
 
.products-soap-fragment11 {
  display: contents;
}
 
.products-soap-text11 {
  display: inline-block;
}
 
.products-soap-fragment12 {
  display: contents;
}
 
.products-soap-text12 {
  display: inline-block;
}
 
.products-soap-fragment13 {
  display: contents;
}
 
.products-soap-text13 {
  display: inline-block;
}
 
.products-soap-fragment14 {
  display: contents;
}
 
.products-soap-text14 {
  display: inline-block;
}
 
.products-soap-fragment15 {
  display: contents;
}
 
.products-soap-text15 {
  display: inline-block;
}
 
.products-soap-fragment16 {
  display: contents;
}
 
.products-soap-text16 {
  display: inline-block;
}
 
.products-soap-fragment17 {
  display: contents;
}
 
.products-soap-text17 {
  display: inline-block;
}
 
.products-soap-fragment18 {
  display: contents;
}
 
.products-soap-text18 {
  display: inline-block;
}
 
.products-soap-fragment19 {
  display: contents;
}
 
.products-soap-text19 {
  display: inline-block;
}
 
.products-soap-fragment20 {
  display: contents;
}
 
.products-soap-text20 {
  display: inline-block;
}
 
.products-soap-fragment21 {
  display: contents;
}
 
.products-soap-text21 {
  display: inline-block;
}
 
.products-soap-fragment22 {
  display: contents;
}
 
.products-soap-text22 {
  display: inline-block;
}
 
.products-soap-fragment23 {
  display: contents;
}
 
.products-soap-text23 {
  display: inline-block;
}
 
.products-soap-fragment24 {
  display: contents;
}
 
.products-soap-text24 {
  display: inline-block;
}
 
.products-soap-fragment25 {
  display: contents;
}
 
.products-soap-text25 {
  display: inline-block;
}
 
.products-soap-fragment26 {
  display: contents;
}
 
.products-soap-text28 {
  display: inline-block;
}
 
.products-soap-fragment27 {
  display: contents;
}
 
.products-soap-text31 {
  display: inline-block;
}
 
.products-soap-fragment28 {
  display: contents;
}
 
.products-soap-text34 {
  display: inline-block;
}
 
.products-soap-fragment29 {
  display: contents;
}
 
.products-soap-text35 {
  display: inline-block;
}
 
.products-soap-fragment30 {
  display: contents;
}
 
.products-soap-text36 {
  display: inline-block;
}
 
.products-soap-fragment31 {
  display: contents;
}
 
.products-soap-text37 {
  display: inline-block;
}
 
.products-soap-fragment32 {
  display: contents;
}
 
.products-soap-text38 {
  display: inline-block;
}
 
.products-soap-fragment33 {
  display: contents;
}
 
.products-soap-text39 {
  display: inline-block;
}
 
.products-soap-fragment34 {
  display: contents;
}
 
.products-soap-text40 {
  display: inline-block;
}
 
.products-soap-fragment35 {
  display: contents;
}
 
.products-soap-text43 {
  display: inline-block;
}
 
.products-soap-fragment36 {
  display: contents;
}
 
.products-soap-text46 {
  display: inline-block;
}
 
.products-soap-fragment37 {
  display: contents;
}
 
.products-soap-text49 {
  display: inline-block;
}
 
.products-soap-fragment38 {
  display: contents;
}
 
.products-soap-text52 {
  display: inline-block;
}
 
.products-soap-fragment39 {
  display: contents;
}
 
.products-soap-text53 {
  display: inline-block;
}
 
.products-soap-fragment40 {
  display: contents;
}
 
.products-soap-text54 {
  display: inline-block;
}
 
.products-soap-fragment41 {
  display: contents;
}
 
.products-soap-text55 {
  display: inline-block;
}
</style>
